import React from 'react';
import { CheckCircle, AlertTriangle, Clock } from 'lucide-react';

interface PortalGuruModalPresensiTepatProps {
    onClose: () => void;
    type: 'masuk' | 'pulang';
    status: 'tepat_waktu' | 'terlambat' | 'pulang_cepat' | 'lembur' | 'tidak_presensi_pulang';
    /** Ringkasan diagnosis kecepatan (kecil, untuk dilaporkan bila lambat). */
    diagnostic?: string;
}

export const PortalGuruModalPresensiTepat: React.FC<PortalGuruModalPresensiTepatProps> = ({ onClose, type, status, diagnostic }) => {
    let title = 'Presensi Berhasil!';
    let message = 'Alhamdulillah, data presensi Anda telah tersimpan.';
    let quote = '"Bekerjalah karena Allah, sesungguhnya Allah mencintai hamba-Nya yang bersungguh-sungguh dalam beramal."';
    let Icon = CheckCircle;
    let iconColor = 'text-green-600';
    let iconBg = 'bg-green-100';
    let ringColor = 'ring-green-50';

    if (type === 'masuk') {
        if (status === 'tepat_waktu') {
            message = 'Alhamdulillah, Anda hadir tepat waktu. Semoga hari ini penuh berkah.';
        } else if (status === 'terlambat') {
            title = 'Presensi Tercatat';
            message = 'Data kehadiran Anda sudah masuk, namun tercatat terlambat. Mari kita perbaiki kedisiplinan demi keberkahan waktu kita.';
            quote = '"Waktu itu ibarat pedang, jika engkau tidak menebasnya, maka ia yang akan menebasmu. (Imam Syafii)"';
            Icon = Clock;
            iconColor = 'text-amber-600';
            iconBg = 'bg-amber-100';
            ringColor = 'ring-amber-50';
        }
    } else {
        // Pulang
        if (status === 'tepat_waktu' || status === 'lembur') {
            title = 'Presensi Pulang Berhasil';
            message = 'Terima kasih atas dedikasi Anda hari ini. Selamat beristirahat.';
            quote = '"Dan Katakanlah: Bekerjalah kamu, maka Allah dan Rasul-Nya serta orang-orang mukmin akan melihat pekerjaanmu itu." (QS. At-Taubah: 105)';
        } else if (status === 'pulang_cepat') {
            title = 'Pulang Cepat Tercatat';
            message = 'Presensi pulang Anda telah dicatat. Semoga urusan Anda dimudahkan Allah SWT.';
            quote = '"Sebaik-baik manusia adalah yang paling bermanfaat bagi orang lain."';
            Icon = Clock;
            iconColor = 'text-orange-600';
            iconBg = 'bg-orange-100';
            ringColor = 'ring-orange-50';
        } else if (status === 'tidak_presensi_pulang') {
            title = 'Status Diperbarui';
            message = 'Status Anda tercatat "Tidak Presensi Pulang" karena melewati batas waktu. Mohon untuk lebih teliti melakukan checkout di lain waktu.';
            quote = '"Sesungguhnya Allah menyukai apabila salah seorang dari kalian melakukan suatu pekerjaan, ia melakukannya dengan itqan (tekun/rapi)." (HR. Baihaqi)';
            Icon = AlertTriangle;
            iconColor = 'text-red-600';
            iconBg = 'bg-red-100';
            ringColor = 'ring-red-50';
        }
    }

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300 text-center">
                <div className={`mx-auto w-24 h-24 rounded-full ${iconBg} flex items-center justify-center mb-6 ring-8 ${ringColor}`}>
                    <Icon size={64} className={iconColor} />
                </div>
                <h3 className="text-2xl font-bold text-[#111813] tracking-tight mb-2">{title}</h3>
                <p className="text-sm text-[#63886f] mb-8 leading-relaxed px-2">{message}</p>

                <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-4 mb-8 text-left relative overflow-hidden">
                    <span className="material-symbols-outlined absolute top-2 right-2 text-emerald-200 text-4xl -rotate-12 select-none opacity-20 font-serif">"</span>
                    <p className="text-xs leading-relaxed font-medium text-emerald-800 italic relative z-10">
                        {quote}
                    </p>
                </div>

                <button
                    onClick={onClose}
                    className="w-full py-3.5 bg-[#40513B] hover:bg-[#344230] text-white font-bold rounded-xl shadow-lg shadow-[#40513B]/25 transition-all active:scale-[0.98]"
                >
                    Aamiin, Mengerti
                </button>
                {diagnostic && (
                    <p className="mt-3 text-[9px] leading-snug text-gray-400 font-mono break-words">{diagnostic}</p>
                )}
            </div>
        </div>
    );
};
